<template>
	<sup v-if="wrapper" class="legal-link-wrapper">
		<component
			:is="asSpan ? 'span' : 'a'"
			:href="asSpan ? undefined : '#'"
			class="legal-link"
			:class="[customClass, { 'legal-link--text': asSpan }]"
			:data-legal="name"
			:aria-label="asSpan ? undefined : ariaLabel"
		></component>
	</sup>
	<component
		v-else
		:is="asSpan ? 'span' : 'a'"
		:href="asSpan ? undefined : '#'"
		class="legal-link"
		:class="[customClass, { 'legal-link--text': asSpan }]"
		:data-legal="name"
		:aria-label="asSpan ? undefined : ariaLabel"
	></component>
</template>

<script setup>
import { computed, getCurrentInstance, nextTick, onBeforeUnmount, onMounted } from 'vue';
import {
	getLegalByName,
	getLegalLinkLabel,
	syncVueLegalLink
} from './legal-shared.js';

const props = defineProps({
	name: { type: String, required: true },
	customClass: { type: String, default: '' },
	wrapper: { type: Boolean, default: false },
	asSpan: { type: Boolean, default: false }
});

const instance = getCurrentInstance();
const linkId = `vue-legal-link-${instance?.uid}`;
const ariaLabel = computed(() => getLegalLinkLabel());

const registerLink = async () => {
	await nextTick();

	if (!getLegalByName(props.name)) return;

	syncVueLegalLink(linkId, props.name);
};

onMounted(() => {
	registerLink();
});

onBeforeUnmount(() => {
	syncVueLegalLink(linkId, null);
});
</script>